import { createContext, useReducer, useState, useContext } from 'react'

export const FirstServerContext = createContext() 

export const firstServerReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FIRSTSERVER':
            return { firstServers: action.payload }
        case 'CREATE_FIRSTSERVER':
            // Add to combinedData array inside the object
            return {
                firstServers: {
                    ...state.firstServers,
                    combinedData: [
                        action.payload,
                        ...(state.firstServers?.combinedData || [])
                    ],
                },
            }
        case 'UPDATE_FIRSTSERVER':
            return { firstServers: action.payload }
        case 'DELETE_FIRSTSERVER':
            return { firstServers: action.payload }
        default:
            return state
    }
}

export const FirstServerContextProvider = ({children}) => {
    const [state, dispatch] = useReducer(firstServerReducer, { firstServers: [] })
    const [targetFirstServer, setTargetFirstServer] = useState(null)
    return (
      <FirstServerContext.Provider 
        value={{ ...state, dispatch, targetFirstServer: targetFirstServer, setTargetFirstServer: setTargetFirstServer}}>
          { children }
      </FirstServerContext.Provider>
    )
}

export const useFirstServerContext = () => {
    const context = useContext(FirstServerContext)
    if(!context) throw Error('useFirstServerContext must be used inside an FirstServerContextProvider')
    return context
}